<script setup lang="ts">
    import { ChevronDoubleLeftIcon } from '@heroicons/vue/16/solid';
    import { SidebarFooter, SidebarMenu, SidebarMenuItem, SidebarMenuButton, useSidebar } from '@/shared/ui/Sidebar';

    const sidebar = useSidebar();
</script>
<template>
    <SidebarFooter class="p-4">
        <SidebarMenu>
            <SidebarMenuItem>
                <SidebarMenuButton
                    tooltip="Expand"
                    @click="sidebar.toggleSidebar"
                >
                    <ChevronDoubleLeftIcon class="group-data-[state=collapsed]:rotate-180 transition-transform" />
                    <span>Collapse</span>
                </SidebarMenuButton>
            </SidebarMenuItem>
        </SidebarMenu>
    </SidebarFooter>
</template>
